import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'zikatagov-logo',
  template: `
    <img [src]="logoSrc" [alt]="altText" [ngStyle]="{'width': width + 'px', 'height': height + 'px'}">
  `,
   standalone: true,
   imports: [CommonModule],
  styles: [`
    :host {
      display: inline-block;
    }
    img {
      object-fit: contain;
    }
  `]
})
export class LogoComponent {
  @Input() logoSrc = 'assets/images/Ellipse 2.svg';
  @Input() altText = 'Company Logo';
  @Input() width = 40;
  @Input() height = 40;
}